export var ChatRoutes;
(function (ChatRoutes) {
    ChatRoutes["CHAT"] = "chat";
})(ChatRoutes || (ChatRoutes = {}));
